import { IOption } from "../../classes/package-listing"
import * as React from 'react';

import Filter from '../../components/filters/filter';
import FixedFilter from '../../components/filters/fixed-filter';
import ClearAll from '../../components/filters/clear-all';

import { FiltersContainerViewProps } from '../../components/filters/container';


const FiltersListView: React.StatelessComponent<FiltersContainerViewProps> = props => {
    return (
        <ul className="ace-filters-list ace-filters-list-centered">
            {props.isFixedPackage ?
                <>
                    {props.text.productionFilterDefaultValue ?
                        <FixedFilter propertyToFilter="productionSeasonId" propertyToDisplay="title" sortFunction={null} filterName={props.text.productionFilterDefaultValue} noSelectionText={props.text.productionFilterDefaultValue} />
                        : null
                    }
                    {props.text.dayOfWeekFilterDefaultValue ?
                        <FixedFilter propertyToFilter="dayOfWeekString" propertyToDisplay="dayOfWeekString" sortFunction={sortDayOfWeek.bind(this)} filterName={props.text.dayOfWeekFilterLabel} noSelectionText={props.text.dayOfWeekFilterDefaultValue} />
                        : null
                    }
                    {props.text.timeSlotDefaultValue ?
                        <FixedFilter propertyToFilter="timeSlotString" propertyToDisplay="timeSlotString" sortFunction={null} filterName={props.text.timeSlotDefaultValue} noSelectionText={props.text.timeSlotDefaultValue} />
                        : null
                    }
                    {props.genre == null && props.text.genreFilterDefaultValue ?
                        <FixedFilter propertyToFilter="genre" propertyToDisplay="genre" sortFunction={null} filterName={props.text.genreFilterDefaultValue} noSelectionText={props.text.genreFilterDefaultValue} />
                        : null
                    }
                </>
                :
                <>
                    <Filter propertyToFilter="productionSeasonId" propertyToDisplay="title" sortFunction={null} filterName={props.text.productionFilterLabel} noSelectionText={props.text.productionFilterDefaultValue} />
                    <Filter propertyToFilter="dayOfWeekString" propertyToDisplay="dayOfWeekString" sortFunction={sortDayOfWeek.bind(this)} filterName={props.text.dayOfWeekFilterLabel} noSelectionText={props.text.dayOfWeekFilterDefaultValue} />
                    <Filter propertyToFilter="timeSlotString" propertyToDisplay="timeSlotString" sortFunction={null} filterName={props.text.timeSlotFilterLabel} noSelectionText={props.text.timeSlotDefaultValue} />
                </>
            }
            
        </ul>
    )
}

function sortDayOfWeek(optionA: IOption, optionB: IOption) {
    const dayOfWeekList = ["Weekdays", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

    return dayOfWeekList.indexOf(optionA.value) - dayOfWeekList.indexOf(optionB.value);
}

const FiltersContainerView: React.StatelessComponent<FiltersContainerViewProps> = props => {
    return (
        <>
            
            <div className={`ace-filters`}>
                <FiltersListView {...props}></FiltersListView>
                <div className="ace-filters-clear">
                    <ClearAll />
                </div>
            </div>
        </>
    );
}

export default FiltersContainerView;